import {
  FETCH_PROGRAM_REQUEST,
  FETCH_PROGRAM_SUCCESS,
  FETCH_PROGRAM_FAILURE,
  FETCH_PROGRAM_WITH_ID_REQUEST,
  FETCH_PROGRAM_WITH_ID_FAILURE,
  FETCH_PROGRAM_WITH_ID_SUCCESS,
  CLEAR_STORE,
  FETCH_PROGRAM_STATS_REQUEST,
  FETCH_PROGRAM_STATS_SUCCESS,
  FETCH_PROGRAM_STATS_FAILURE,
  FETCH_PROCESSORS_REQUEST,
  FETCH_PROCESSORS_SUCCESS,
  FETCH_PROCESSORS_FAILURE,
} from './programActions';
import type { Processor } from '../types/domain';

export interface ProgramState {
  loading: boolean;
  program_list: any;
  error: string | null;
  stats: any;
  statsLoading: boolean;
  statsError: string | null;
  program?: any;
  processors: Processor[] | null;
  processorsLoading: boolean;
  processorsError: string | null;
}

const initialState: ProgramState = {
  loading: true,
  program_list: null,
  error: null,
  stats: null,
  statsLoading: false,
  statsError: null,
  processors: null,
  processorsLoading: false,
  processorsError: null,
};

interface ProgramAction {
  type: string;
  payload?: any;
  error?: any;
}

const programReducer = (
  state: ProgramState = initialState,
  action: ProgramAction,
): ProgramState => {
  switch (action.type) {
    case FETCH_PROGRAM_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_PROGRAM_SUCCESS:
      return {
        ...state,
        loading: false,
        program_list: action.payload,
      };
    case FETCH_PROGRAM_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error ?? null,
      };
    case FETCH_PROGRAM_WITH_ID_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_PROGRAM_WITH_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        program: action.payload,
      };
    case FETCH_PROGRAM_WITH_ID_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error ?? null,
      };
    case CLEAR_STORE:
      return initialState;
    case FETCH_PROGRAM_STATS_REQUEST:
      return {
        ...state,
        statsLoading: true,
        statsError: null,
      };
    case FETCH_PROGRAM_STATS_SUCCESS:
      return {
        ...state,
        statsLoading: false,
        stats: action.payload,
      };
    case FETCH_PROGRAM_STATS_FAILURE:
      return {
        ...state,
        statsLoading: false,
        statsError: action.error ?? null,
      };
    case FETCH_PROCESSORS_REQUEST:
      return {
        ...state,
        processorsLoading: true,
        processorsError: null,
      };
    case FETCH_PROCESSORS_SUCCESS:
      return {
        ...state,
        processorsLoading: false,
        processors: action.payload ?? null,
      };
    case FETCH_PROCESSORS_FAILURE:
      return {
        ...state,
        processorsLoading: false,
        processorsError: action.error ?? null,
      };
    default:
      return state;
  }
};

export default programReducer;

